import { hookstate } from "@hookstate/core";
import { WebPurchasePayloadTypes } from "../components/payments/api/paymentApi";

// Global state that is used to store the pending auth payment config
export const pendingAuthPaymentConfigStore = hookstate<
  WebPurchasePayloadTypes | undefined
>(undefined);
